import React from 'react';
import useStore from '../useStore';

const DisplayEmail = () => {
    const userEmail = useStore((state) => state.userEmail);
    
    console.log('Email in DisplayEmail:', userEmail);

    return (
        <div>
            <h2>User Email</h2>
            <p>{userEmail ? userEmail : "No email available"}</p>
        </div>
    );
};

export default DisplayEmail;
